

import { mapGetters } from 'vuex';
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)
import { nextTick } from 'vue';

export default {

	data() {
		return {
			model: [
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 }
			],
			page: {
				'ja':`
### **第1条（目的）**

本利用規約（以下「本規約」といいます。）は、Garden Eight（以下「当社」といいます。）が提供するチャットボットサービス（以下「本サービス」といいます。）の利用条件を定めるものです。利用者（以下「ユーザー」といいます。）は、本サービスを利用することにより、本規約に同意したものとみなされます。

### **第2条（適用）**

本規約は、本サービスの提供条件及び本サービスの利用のみに関して当社とユーザーの権利義務関係を定めることを目的とし、ユーザーと当社との本サービスの利用に関わる関係のみに適用されます。

### **第3条（利用条件）**

1. ユーザーは、本サービスを利用する際に、真実かつ正確な情報を提供するものとします。
2. ユーザーは、本サービスを利用するにあたり、以下の行為を行ってはなりません。
    - 法令または公序良俗に違反する行為
    - 他のユーザー、第三者または当社の権利を侵害する行為
    - 虚偽の情報を提供する行為
    - 本サービスの運営を妨害する行為
    - スパム行為、荒らし行為、不正行為
    - その他、当社が不適切と判断する行為

### **第4条（サービスの提供）**

1. 当社は、本サービスの内容および提供方法を自由に変更できるものとします。
2. 当社は、事前の通知なく本サービスを一時的に停止または終了することができるものとします。

### **第5条（免責事項）**

1. 当社は、本サービスの利用により生じたいかなる損害についても、当社に故意または重大な過失がない限り、責任を負いません。
2. 当社は、本サービスに関してユーザーと他のユーザーまたは第三者との間に生じたトラブルについて、責任を負いません。
3. 当社は、AIによる回答の正確性を保証しません。ユーザーは、AIが提供する情報が必ずしも正確であるとは限らないことを理解し、自己の判断で利用するものとします。
4. ユーザーは、本サービスに情報を入力（以下「インプット」といいます）することによって本サービスから出力された結果（以下「アウトプット」といいます）を受け取ることができます。ユーザーは、本コンテンツが適用法令又は本利用規約に違反していないことを確認しなければならないことに加えて、インプット及びアウトプットに対して責任を負います。ユーザーは、当社の本サービスに提供するインプットに必要なすべての権利、ライセンス、及び許諾を得ていることを表明し、保証します。

### **第6条（権利帰属）**

本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。

### **第7条（規約の変更）**

当社は、本規約を随時変更することができるものとします。変更後の規約は、本サービスに掲載された時点から効力を生じるものとします。

### **第8条（分離可能性）**

本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または一部執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。

### **第9条（準拠法および裁判管轄）**

本規約は、日本法に準拠し、日本法に従って解釈されます。本サービスに関する一切の紛争については、東京地方裁判所を専属的合意管轄裁判所とします。
`,
				'en':`
### **第1条（目的）**

本利用規約（以下「本規約」といいます。）は、Garden Eight（以下「当社」といいます。）が提供するチャットボットサービス（以下「本サービス」といいます。）の利用条件を定めるものです。利用者（以下「ユーザー」といいます。）は、本サービスを利用することにより、本規約に同意したものとみなされます。

### **第2条（適用）**

本規約は、本サービスの提供条件及び本サービスの利用のみに関して当社とユーザーの権利義務関係を定めることを目的とし、ユーザーと当社との本サービスの利用に関わる関係のみに適用されます。

### **第3条（利用条件）**

1. ユーザーは、本サービスを利用する際に、真実かつ正確な情報を提供するものとします。
2. ユーザーは、本サービスを利用するにあたり、以下の行為を行ってはなりません。
    - 法令または公序良俗に違反する行為
    - 他のユーザー、第三者または当社の権利を侵害する行為
    - 虚偽の情報を提供する行為
    - 本サービスの運営を妨害する行為
    - スパム行為、荒らし行為、不正行為
    - その他、当社が不適切と判断する行為

### **第4条（サービスの提供）**

1. 当社は、本サービスの内容および提供方法を自由に変更できるものとします。
2. 当社は、事前の通知なく本サービスを一時的に停止または終了することができるものとします。

### **第5条（免責事項）**

1. 当社は、本サービスの利用により生じたいかなる損害についても、当社に故意または重大な過失がない限り、責任を負いません。
2. 当社は、本サービスに関してユーザーと他のユーザーまたは第三者との間に生じたトラブルについて、責任を負いません。
3. 当社は、AIによる回答の正確性を保証しません。ユーザーは、AIが提供する情報が必ずしも正確であるとは限らないことを理解し、自己の判断で利用するものとします。
4. ユーザーは、本サービスに情報を入力（以下「インプット」といいます）することによって本サービスから出力された結果（以下「アウトプット」といいます）を受け取ることができます。ユーザーは、本コンテンツが適用法令又は本利用規約に違反していないことを確認しなければならないことに加えて、インプット及びアウトプットに対して責任を負います。ユーザーは、当社の本サービスに提供するインプットに必要なすべての権利、ライセンス、及び許諾を得ていることを表明し、保証します。

### **第6条（権利帰属）**

本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。

### **第7条（規約の変更）**

当社は、本規約を随時変更することができるものとします。変更後の規約は、本サービスに掲載された時点から効力を生じるものとします。

### **第8条（分離可能性）**

本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または一部執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。

### **第9条（準拠法および裁判管轄）**

本規約は、日本法に準拠し、日本法に従って解釈されます。本サービスに関する一切の紛争については、東京地方裁判所を専属的合意管轄裁判所とします。
`
			},
			error: null
		};
	},

	computed: {
		...mapGetters([
			'chatAi'
		]),
		pageContent() {
			const lang = this.$i18n.locale;
			const mdContent = this.page[lang];
			return this.$md.render( mdContent );
		}
	},

	head() {
		let _title = 'Garden Eight | Terms of Use';
		let _description = 'Terms of Use';
		return {
			title: _title,
			meta: [
				{
					name: 'description',
					content: _description,
				}
			]
		}
	},

	async fetch ({ store, $http }) {
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}
	},

	mounted(){
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'subpage', slug : 'subpage' },
			prev : null,
			next : null
		});
	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
